import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private router: Router;


    constructor(private injector: Injector) {
    }

    handleError(error) {
        
        
        if (!this.router) {
            this.router = this.injector.get(Router);
        }

        //Don't  set here.
        
        console.log(error.message);
        const errObject = JSON.parse(error.message);
        if (errObject && errObject.status === 401) {

            localStorage.clear();
            this.router.navigate(['login']);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/core/helper/error.Handler.ts